import { gameVolumeState } from '@/components/features/casino/crash/state';
import { VolumeDown } from '@mui/icons-material';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { IconButton, Popover, Slider, Popper } from '@mui/material';
import React from 'react';
import { useAtom } from 'jotai';
import { VolumeWrapper } from './styles';
import useTheme from '@/theme/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  emitPlayCrashBgSound,
  emitStopCrashBgSound,
} from '@/components/features/casino/crash/BgSoundManage/crash-sound-event';
import {
  emitPlayRushBgSound,
  emitStopRushBgSound,
} from '@/components/features/casino/rush/BgSoundManage/sound-event';

/**
 *
 * popover mouseover bug(fuck)
 * https://stackoverflow.com/questions/54705254/how-to-keep-showing-the-popover-on-hovering-on-the-anchorel-and-popover-as-w
 */
const VolumeSetting: React.FC = () => {
  const { theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const volumeBtnRef = React.useRef(null);

  const outTimerRef = React.useRef(null);
  const handleOpen = () => {
    setAnchorEl(volumeBtnRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'volume-popover' : undefined;
  /* ====================== *
   *     handle volume
   * ====================== */
  const [volume, setVolume] = useAtom(gameVolumeState);
  const isMute = volume === 0;
  const handleVolumeChange = (event, newValue) => {
    setVolume(newValue);
  };
  const onClickVolumeIcon = () => {
    handleMute();
    // if (isMobile) {
    //   if (open) {
    //     handleClose();
    //   } else {
    //     handleOpen();
    //     // close popover after 1500ms
    //     outTimerRef.current = setTimeout(() => {
    //       handleClose();
    //     }, 1500);
    //   }
    // } else {
    //   handleMute();
    // }
  };
  const handleMute = () => {
    if (isMute) {
      setVolume(20);
      emitPlayRushBgSound();
      emitPlayCrashBgSound();
    } else {
      setVolume(0);
      emitStopCrashBgSound();
      emitStopRushBgSound();
    }
  };
  /* ====================== *
   *    show popover
   * ====================== */
  const onMouseEnter = () => {
    if (isMobile) return;
    clearTimeout(outTimerRef.current);
    handleOpen();
  };
  const onMouseLeave = () => {
    if (isMobile) return;
    outTimerRef.current = setTimeout(() => {
      handleClose();
    }, 500);
  };
  return (
    <>
      <IconButton
        onClick={onClickVolumeIcon}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={volumeBtnRef}
        sx={{
          color: (theme) =>
            !isMute ? theme.palette.primary.main : 'rgba(255, 255, 255, 0.70)',
        }}
      >
        {isMute ? <VolumeOffIcon /> : <VolumeDown />}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          pointerEvents: 'none',
        }}
        PaperProps={{
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          sx: {
            pointerEvents: 'auto',
          },
        }}
      >
        <VolumeWrapper
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onTouchEnd={onMouseLeave}
          onTouchStart={onMouseEnter}
        >
          <Slider
            aria-label="Volume"
            value={volume}
            onChange={handleVolumeChange}
          />
          {volume}
        </VolumeWrapper>
      </Popover>
    </>
  );
};

export default VolumeSetting;
